import React from 'react'
import { Controller, FieldError } from 'react-hook-form'
import { Content, Error, Field, Label } from '../styles'
import { DateRangePicker } from 'react-date-range'

// @ts-ignore:next-line
import * as rdrLocales from 'react-date-range/dist/locale'

import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import Popup from 'reactjs-popup'
import format from 'date-fns/format'
import { defaultInputRanges, defaultStaticRanges } from './defaultsRange'
import { useTheme } from 'styled-components'

export interface DateRangeInputProps {
  placeholder?: string
  control: any
  label?: string
  error?: FieldError
  gray?: boolean
  name: string
  children?: any
}

const DateRangeInput: React.FunctionComponent<DateRangeInputProps> = ({
  control,
  label,
  error,
  gray,
  name,
  placeholder = 'Selecionar',
  children,
}) => {
  const [inpout, setInput] = React.useState('')

  const theme: any = useTheme()
  const selectionRange = {
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  }

  return (
    <Controller
      key={name}
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value } }) => {
        const handleChange = (option: any) => {
          if (option.selection) {
            onChange(option.selection)
            setInput(
              `${format(option.selection.startDate, 'dd-MM-yyyy')} - ${format(
                option.selection.endDate,
                'dd-MM-yyyy',
              )}`,
            )
          } else {
            onChange(null)
          }
        }

        return (
          <>
            {label && (
              <div style={{ display: 'flex', flexDirection: 'row', gap: 15 }}>
                <Label>{label} </Label>
                <div
                  onClick={() => {
                    onChange(null)
                    setInput('')
                  }}
                  style={{ cursor: 'pointer', fontSize: 12 }}
                >
                  Limpar
                </div>
              </div>
            )}

            <Popup
              trigger={
                children ? (
                  children
                ) : (
                  <Content gray={gray}>
                    <Field
                      autoComplete='none'
                      role='presentation'
                      value={!value ? '' : inpout}
                      placeholder={placeholder}
                      error={!!error}
                      onBlur={onBlur}
                      readOnly
                    />
                  </Content>
                )
              }
              position='left top'
            >
              <DateRangePicker
                locale={rdrLocales.pt}
                ranges={[value || selectionRange]}
                onChange={handleChange}
                color={theme.colors.primary}
                rangeColors={[theme.colors.primary]}
                staticRanges={defaultStaticRanges}
                inputRanges={defaultInputRanges}
              />
            </Popup>

            {error && <Error>{error.message}</Error>}
          </>
        )
      }}
    />
  )
}

export default DateRangeInput
